import { Component, OnInit, TemplateRef } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { UserService } from '../../../../services/userService/user.service';
import { environment } from "../../../../../environments/environment";
import { BsModalService, BsModalRef } from "ngx-bootstrap/modal";
import { ToastrService } from "ngx-toastr";
import { Router, ActivatedRoute } from "@angular/router";
import { RolePermissionServiceService } from "../../../../services/rolepermission/role-permission-service.service";
import { RolePermissionService } from "../../../../appService/role-permission.service";

@Component({
  selector: 'app-detailattachment',
  templateUrl: './detailattachment.component.html',
  styleUrls: ['./detailattachment.component.css']
})
export class DetailattachmentComponent implements OnInit {
  orderdoc: any;
  active: string;
  permission: any;
  url: string;
  dft_icn: string;
  downloadurl: string;
  userid: any;
  id: any;
  modalRef: BsModalRef;
  filename: any;
  file: any;
  delNameDel: boolean;
  isCollapsed: boolean;
  type: any;
  fileId: any;
  oneDriveLink: any;

  constructor(
    private route: ActivatedRoute,
    private UserService: UserService,
    private service: RolePermissionService,
    private roleservice: RolePermissionServiceService,
    private modalService: BsModalService,
    private toastr: ToastrService,
    private router: Router,
    private spinner: NgxSpinnerService,
  ) {
    this.active = localStorage.getItem("active_id");
    let decid = localStorage.getItem("editOid");
    decid = decid
      .toString()
      .replace("Ar1t", "=")
      .replace("FGH", "/")
      .replace("THD", "+");
    this.id = this.UserService.decryptData(decid);
    let permi = JSON.parse(localStorage.getItem("Permission"));
    this.permission = this.UserService.decryptData(permi);
  }

  ngOnInit(): void {
    this.url = environment.tempimage;
    this.downloadurl = environment.orderDownloadPath;
    this.dft_icn = environment.default_temp;
    this.getOrderDetails();
  }

  getOrderDetails() {
    let data = {
      "OrderInfoId": this.id,
      "Mode": "View"
    };
    this.spinner.show();
    this.UserService.GetOrderReviewDetailById(data).subscribe((res) => {
      if (res['result'] == 'Success') {
        this.spinner.hide();
        this.orderdoc = res["UploadDocument"];
        this.oneDriveLink = res["UploadDocument"][15].UrlPath;
        this.spinner.hide();
      }
      else if (res['result'] == 'Failed') {
        this.toastr.error(res['Msg']);
        this.spinner.hide();
        this.router.navigate(['/profile']);
      } else {
        this.toastr.error(res['Msg']);
        this.spinner.hide();
      }
    }, (err) => {
      this.spinner.hide();
      if (err && (err.Msg || err.Message)) {
        this.toastr.error(err.Msg || err.Message);
      }      
    });
  }

  orderReviewid = this.route.snapshot.params["id"];

  downloadModal(template: TemplateRef<any>, name, data) {
    if (data) {
      this.filename = name;
      this.file = data;
      this.modalRef = this.modalService.show(template, {
        class: "modal-sm modal-dialog-centered",
      });
    }
  }

  downloadConfirm() {
    this.download();
    this.modalRef.hide();
  }

  decline() {
    this.modalRef.hide();
  }

  download(): any {
    window.open(this.file);
  }

  AddHttpfun(value) {
    if (value) {
      if (value.startsWith("http") || value.startsWith("https")) {
        let b = value;
        window.open(b);
      }
      else {
        let a = 'http://' + value;
        window.open(a);
      }
    }
  }

  openClosefun() {
    this.isCollapsed = !this.isCollapsed;
  }

}
